<!-- src/components/AdminFAB.vue -->
<template>
  <!-- 
    Hiding SS AI Assistant until further notice. 
    To re-enable, remove 'false &&' from the v-if condition below.
  -->
  <div v-if="false && isAdmin" class="hidden lg:block fixed bottom-4 right-4 z-[1000]">
    <!-- The pop-up message box -->
    <div v-if="isPopupOpen" class="bg-white rounded-lg shadow-2xl p-6 w-64 absolute bottom-full right-0 mb-4">
      <div class="flex justify-between items-center mb-2">
        <h3 class="font-bold text-brand-primary">SS AI Assistant</h3>
        <button @click="isPopupOpen = false" class="text-gray-400 hover:text-gray-700">&times;</button>
      </div>
      <p class="text-sm text-gray-600">
        Cutting-Edge AI Coming Soon...
      </p>
    </div>

    <!-- START: CORRECTED FLOATING BUTTON -->
    <button 
      @click="togglePopup" 
      class="w-16 h-16 transition-all duration-300 transform focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-accent rounded-full" 
      aria-label="Open AI Assistant"
    >
      <img 
        src="/images/ai-assistant-icon.png" 
        alt="SS AI Assistant" 
        class="w-full h-full object-cover ai-icon-image transition-all duration-300 transform hover:scale-110"
      >
    </button>
    <!-- END: CORRECTED FLOATING BUTTON -->
  </div>
</template>

<script setup>
import { ref } from 'vue';

defineProps({
  isAdmin: {
    type: Boolean,
    required: true,
  },
});

const isPopupOpen = ref(false);

const togglePopup = () => {
  isPopupOpen.value = !isPopupOpen.value;
};
</script>

<style scoped>
.ai-icon-image:hover {
  filter: drop-shadow(0 0 12px #47BF9E);
}
</style>